import React from "react-router-dom"
import styles from "./Footer.module.scss"
import {FooterNav} from "../molecules/FooterNav";
import {LogoFooter} from "../molecules/LogoFooter";

export const Footer = () =>
    <div className={styles.footer}>


        <h5 className={styles.sender}>
            Jugendkulturfestival <br/>
            5 + 6 September 2025
        </h5>

        <FooterNav/>

        <LogoFooter />

    </div>